import React from 'react';
import { Link } from 'react-router-dom';
import { Search } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import { useAuth } from '../../context/AuthContext';

const TopBar = () => {
  const { language, setLang, translations } = useLanguage();
  const { user } = useAuth();

  return (
    <div className="bg-[#D4AF37] text-[#0B0B0B]">
      <div className="max-w-7xl mx-auto px-4 py-2 flex justify-between items-center">
        <div className="flex items-center gap-2">
          <span className="text-sm font-bold tracking-wider">{translations.slogan}</span>
        </div>
        <div className="flex items-center gap-4 text-sm">
          <button 
            onClick={() => setLang('en')} 
            className={`hover:underline transition-all ${language === 'en' ? 'font-bold underline' : ''}`}
          >
            EN
          </button>
          <span>|</span>
          <button 
            onClick={() => setLang('fr')} 
            className={`hover:underline transition-all ${language === 'fr' ? 'font-bold underline' : ''}`}
          >
            FR
          </button>
          <span className="mx-2">|</span>
          {user ? (
            <Link to={user.role === 'admin' || user.role === 'sub_admin' ? '/admin' : '/dashboard'} className="hover:underline font-bold">
              {language === 'fr' ? 'Mon compte' : 'My Account'}
            </Link>
          ) : (
            <>
              <Link to="/login" data-testid="topbar-login-link" className="hover:underline">
                {language === 'fr' ? 'Se connecter' : 'Sign In'}
              </Link>
              <Link to="/register" className="hover:underline">{translations.signUp}</Link>
            </>
          )}
          <a href="#contact" className="hover:underline">{translations.contact}</a>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
